var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 12.3333C4.05992 12.3333 1.66659 9.94001 1.66659 7.00001C1.66659 4.06001 4.05992 1.66668 6.99992 1.66668C9.93992 1.66668 12.3333 4.06001 12.3333 7.00001C12.3333 9.94001 9.93992 12.3333 6.99992 12.3333ZM6.99992 0.333344C6.12444 0.333344 5.25753 0.505782 4.4487 0.840813C3.63986 1.17584 2.90493 1.66691 2.28587 2.28596C1.03563 3.53621 0.333252 5.2319 0.333252 7.00001C0.333252 8.76812 1.03563 10.4638 2.28587 11.7141C2.90493 12.3331 3.63986 12.8242 4.4487 13.1592C5.25753 13.4942 6.12444 13.6667 6.99992 13.6667C8.76803 13.6667 10.4637 12.9643 11.714 11.7141C12.9642 10.4638 13.6666 8.76812 13.6666 7.00001C13.6666 6.12453 13.4941 5.25762 13.1591 4.44879C12.8241 3.63995 12.333 2.90502 11.714 2.28596C11.0949 1.66691 10.36 1.17584 9.55114 0.840813C8.7423 0.505782 7.8754 0.333344 6.99992 0.333344ZM3.66659 7.66668H10.3333V6.33334H3.66659",
    fill: "#909CA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteInput);
export default __webpack_public_path__ + "static/media/delete-input.29ed57528d7c9f15634bc8bc94e7f655.svg";
export { ForwardRef as ReactComponent };